var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CSSGrid',_vm._g({staticClass:"ux1-computed-grid",attrs:{"gridStyle":_setup.computedStyle}},_setup.computedListeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }